import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

export interface HousingStockCompositionRecord {
  Place: string;
  place_fips: string;
  year: string | number;
  pct_sf_existing: number;
  pct_mf_existing: number;
}

export function useHousingStockCompositionData(place: string | null, placeFips: string | null) {
  const [data, setData] = useState<HousingStockCompositionRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!place || !placeFips) {
      setLoading(false);
      setData([]);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    supabase
      .from('acs_bps_metrics_housing_stock_analysis')
      .select('Place, place_fips, year, pct_sf_existing, pct_mf_existing')
      .eq('Place', place)
      .eq('place_fips', placeFips)
      .gte('year', 2018)
      .lte('year', 2023)
      .order('year', { ascending: true }) // Get the years in order
      .then(({ data: supabaseData, error: supabaseError }) => {
        if (supabaseError) {
          console.error('Error fetching housing stock composition data:', supabaseError);
          setError(supabaseError.message);
          setData([]);
        } else {
          setData(supabaseData || []);
          // Log the latest record for the selected city
          const latest = (supabaseData || []).slice(-1)[0];
          if (latest) {
            console.log(`Selected City: ${latest.Place}`);
            console.log(`  FIPS: ${latest.place_fips}`);
            console.log(`  MF Share: ${latest.pct_mf_existing?.toFixed(2)}%`);
            console.log(`  SF Share: ${latest.pct_sf_existing?.toFixed(2)}%`);
            console.log(`  Year: ${latest.year}`);
          }
        }
        setLoading(false);
      });
  }, [place, placeFips]);

  return { data, loading, error };
} 